import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_g3x4hvk56r: FaireCollectionEntity = {
  token: "pbc_g3x4hvk56r",
  type: "collection",
  name: "USA Shop ✨✨",
  heroImageUrl:
    "https://cdn.faire.com/fastly/eef4e9dc1aaedb69c25e4182e159a0c34ff020f337e63b4e11e4846faee52a87.jpeg",
  itemCount: 40,
  description:
    "Red, White and Cute! This collection is perfect for watching fireworks, a backyard BBQ, and fun all Summer long!",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:38.664Z",
    importedBy: "entity-db-import-collections",
  },
};
